import React from 'react'
import CIcon from '@coreui/icons-react'
import { cilChatBubble, cilArrowCircleTop } from '@coreui/icons'

const AppFloatingButtons = () => {
  // const currentUser = useAppSelector(selectCurrentUser)

  return (
    <div className="theme-float-buttons-container">
      <div className="theme-float-button">
        <CIcon icon={cilChatBubble} size="xl" />
      </div>

      <div className="theme-float-button">
        <CIcon icon={cilArrowCircleTop} size="3xl" />
      </div>
    </div>
  )
}

export default React.memo(AppFloatingButtons)
